import styled from "styled-components";

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex-direction: column;
  color: black;

  i {
    padding: 5px 7px;
    border: 1px solid;
    border-radius: 20px;
    display: flex;
    gap: 5px;

    span:nth-child(1) {
      padding: 10px;
      border-radius: 10px;
      background-color: black;
      height: 0px;
      width: 0px;
      pointer-events: none;
      animation: 1s emojiLoading1 linear infinite;

      @keyframes emojiLoading1 {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 0;
        }
      }
    }
    span:nth-child(2) {
      padding: 10px;
      border-radius: 10px;
      height: 0px;
      width: 0px;
      pointer-events: none;
      background-color: black;
      animation: 1s emojiLoading2 linear infinite;

      @keyframes emojiLoading2 {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    }
    span:nth-child(3) {
      padding: 10px;
      border-radius: 10px;
      background-color: black;
      height: 0px;
      width: 0px;
      pointer-events: none;
      animation: 1s emojiLoading3 linear infinite;

      @keyframes emojiLoading3 {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    }
  }
  em {
    font-size: 12px;
  }
`;
